import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const DatasourceDownstreamMetricsQueryGql: DocumentNode = gql`
query DatasourceDownstreamMetricsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
